/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

export default function SafeHTML({children, className = '', el='span'}) {

  const replaceNbsp = (str) => {
    return str.replace(/&amp;nbsp;/g, '\u00A0'); // Unicode for non-breaking space
  };

  let props = {
    className,
  }

  if (typeof(children) === 'string') {
    props.dangerouslySetInnerHTML =  {__html: replaceNbsp(children)
    };
  } else {
    props.children = children;
  }

  return children ? React.createElement(
    el,
    props,
  ) : null;

}

SafeHTML.propTypes = {
  children: PropTypes.node,
};
